export default "__VITE_ASSET__DEtOhKLA__"